
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import Descriptions from '@/components/descriptions.vue'
import Nodata from '@/components/page/nodata.vue'
import api from '@/api/allApi'
export default defineComponent({
  components: { Descriptions, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    theme: {
      type: String,
      default: function() {
        return 'light'
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      spinning: true
    })
    pageData.list = computed(() => {
      return setlist()
    })
    function setlist() {
      const _data = (props.pageSourceData || {}).Bri || {}
      let list: any = []
      if (!(props.pageSourceData || {}).Bri) return []
      if (_data.Concept || _data.Industry || _data.Major) {
        const content = ((_data || {}).Industry ? (_data || {}).Industry : '—') + ((_data || {}).IndustryID ? '（' + (_data || {}).IndustryID + '）' : '')
        list = [
          {
            title: '所属行业',
            key: 'sshy',
            content: content,
            opencontent: false,
            width: '150px',
            open: false
          },
          {
            title: '涉及概念',
            key: 'sshy',
            content: (_data || {}).Concept,
            opencontent: false,
            width: 'calc(100 - 150px)',
            open: false
          },
          {
            title: '主营业务',
            key: 'sshy',
            content: (_data || {}).Major,
            opencontent: false,
            open: false,
            collapse: true
          }
        ]
      }
      pageData.spinning = false
      // context.emit('setspinning', false)
      return list
    }
    return {
      ...toRefs(pageData),
      setlist
    }
  }
})
